import { motion } from "framer-motion";
import { useLang } from "../i18n";

const lineVariants = { hidden: {}, show: {} };

const innerVariants = {
    hidden: { y: "115%" },
    show: (delay) => ({ y: 0, transition: { duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] } }),
};

const Line = ({ children, delay }) => (
    <motion.span
        className="block overflow-hidden py-1"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={lineVariants}
    >
        <motion.span className="block" variants={innerVariants} custom={delay}>
            {children}
        </motion.span>
    </motion.span>
);

export const Statement = () => {
    const { t } = useLang();
    return (
        <section className="relative py-28 sm:py-40 px-6 text-center overflow-hidden" data-testid="tagline-statement">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full bg-gold/10 blur-3xl pointer-events-none" />
            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
                className="relative text-xs tracking-[0.35em] uppercase text-golddark mb-10"
            >
                {t("statement.overline")}
            </motion.p>
            <h2 className="relative font-serif italic text-3xl sm:text-4xl lg:text-5xl leading-snug tracking-tight text-charcoal max-w-4xl mx-auto" data-testid="tagline-text">
                <Line delay={0.1}>{t("statement.l1")}</Line>
                <Line delay={0.25}>
                    {t("statement.l2a")}
                    <em className="not-italic text-golddark">{t("statement.l2b")}</em>
                </Line>
            </h2>
            <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="relative mx-auto mt-12 h-px w-24 bg-gold origin-center"
            />
        </section>
    );
};
